module.exports = __webpack_public_path__ + "static/media/255px_logo_bug_tm.5199a96a.png";